import { render, staticRenderFns } from "./listOweFeeList.vue?vue&type=template&id=baf390bc&scoped=true"
import script from "./listOweFeeList.vue?vue&type=script&lang=js"
export * from "./listOweFeeList.vue?vue&type=script&lang=js"
import style0 from "./listOweFeeList.vue?vue&type=style&index=0&id=baf390bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf390bc",
  null
  
)

export default component.exports